// import echarts from "echarts";
// import * as echarts from "echarts";
export function loadChart(myChart, innerData, outerData, name, unit) {
  // let echartData = {
  //   inner: [
  //     {
  //       value: 700,
  //       unit: "个",
  //       name: "行业大类1"
  //     },
  //     {
  //       value: 679,
  //       unit: "个",
  //       name: "行业大类2"
  //     },
  //     {
  //       value: 1548,
  //       unit: "个",
  //       name: "行业大类3"
  //     }
  //   ],
  //   outer: [
  //     {
  //       value: 310,
  //       unit: "个",
  //       name: "邮件营销"
  //     },
  //     {
  //       value: 234,
  //       unit: "个",
  //       name: "联盟广告"
  //     },
  //     {
  //       value: 335,
  //       unit: "个",
  //       name: "视频广告"
  //     },
  //     {
  //       value: 548,
  //       unit: "个",
  //       name: "百度"
  //     },
  //     {
  //       value: 351,
  //       unit: "个",
  //       name: "谷歌"
  //     },
  //     {
  //       value: 247,
  //       unit: "个",
  //       name: "必应"
  //     }
  //   ]
  // };
  if (myChart) {
    myChart.clear();
  }
  if (innerData.length > 0) {
    // 设置
    myChart.setOption({
      color: [
        "#2ec7c9",
        "#b6a2de",
        "#5ab1ef",
        "#ffb980",
        "#d87a80",
        "#8d98b3",
        "#FFEA01",
        "#B8D07C",
        "#fca4bb",
        "#dc69aa",
        "#07a2a4",
        "#9a7fd1",
        "#588dd5",
        "#f5994e",
        "#c05050",
        "#59678c",
        "#c9ab00",
        "#7eb00a",
        "#6f5553",
        "#c14089"
      ],
      tooltip: {
        trigger: "item",
        padding: 1,
        formatter: "{a} <br />{b}: {c}" + unit + " ({d}%)"
        // formatter: function(param) {
        //   var resultTooltip =
        //     "<div style='background:rgba(13,5,30,.6);border:1px solid rgba(255,255,255,.2);padding:5px;border-radius:3px;'>" +
        //     "<div style='text-align:center;'>" +
        //     param.name +
        //     "</div>" +
        //     "<div style='padding-top:5px;'>" +
        //     "<span style=''> " +
        //     name +
        //     ": </span>" +
        //     "<span style=''>" +
        //     param.value +
        //     "</span><span>" +
        //     unit +
        //     "</span>" +
        //     "</div>" +
        //     "</div>";
        //   return resultTooltip;
        // }
      },
      legend: {
        show: true,
        // icon: "circle",
        orient: "vertical",
        top: 40,
        right: "4%",
        itemWidth: 10,
        itemHeight: 10,
        // itemGap: 30,
        textStyle: {
          color: "#FFFFFF",
          fontSize: 12
        }
      },
      series: [
        {
          name: name,
          type: "pie",
          radius: [0, "50%"],
          center: ["30%", "53%"],
          itemStyle: {
            normal: {
              borderColor: "#fff",
              borderWidth: 0
            }
          },
          label: {
            normal: {
              show: false,
              position: "inner",
              color: "#fff"
            }
          },
          labelLine: {
            normal: {
              show: false
            }
          },
          data: innerData
          // data: echartData.inner
        },
        {
          name: name,
          type: "pie",
          radius: ["60%", "85%"],
          center: ["30%", "53%"],
          labelLine: {
            normal: {
              length: 10,
              length2: 10,
              // length2: 140,
              lineStyle: {
                color: "#e6e6e6"
              }
            }
          },
          label: {
            normal: {
              show: false,
              formatter: params => {
                return (
                  "{icon|●}{name|" +
                  params.name +
                  "}{percent|" +
                  params.percent.toFixed(1) +
                  "%}{value|" +
                  params.value +
                  "}"
                );
              },
              // padding: [0, -130, 25, -130],
              rich: {
                // color: "#fff",
                icon: {
                  // fontSize: 16
                },
                name: {
                  fontSize: 12,
                  padding: [0, 5, 0, 5],
                  color: "#fff"
                },
                percent: {
                  color: "#fff",
                  padding: [0, 5, 0, 0]
                },
                value: {
                  fontSize: 12
                  // fontWeight: "bold",
                  // color: "#fff"
                }
              }
            }
          },
          data: outerData
          // data: echartData.outer,
        }
      ]
    });
  } else {
    //空状态
    // myChart.clear();
    const msgOption = {
      title: {
        show: true,
        textStyle: {
          color: "grey",
          fontSize: 20
        },
        text: "暂无数据",
        left: "center",
        top: "center"
      },
      xAxis: {
        show: false
      },
      yAxis: {
        show: false
      },
      series: []
    };
    myChart.setOption(msgOption);
  }
}
